import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './config/root.config';
import { RootComponent } from '@components/root/root.component';

// pdfjs-dist currently uses Promise.try(), which isn't a standard Promise API.
// Provide a small, safe polyfill so PDF rendering doesn't crash at runtime.
(() => {
  const P = Promise as any;
  if (typeof P.try !== 'function') {
    P.try = (fn: any, ...args: any[]) =>
      new Promise((resolve, reject) => {
        try {
          resolve(typeof fn === 'function' ? fn(...args) : fn);
        } catch (e) {
          reject(e);
        }
      });
  }
})();

bootstrapApplication(RootComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
  .catch((err) => console.error(err));
